import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { Button, TextField, Dialog, Typography } from '@mui/material';
import { useStyles } from '../../../../theme/Modals';
import { toast } from 'react-toastify';
import Preloader from '../../../global/Preloader';
import { useMutation } from '@apollo/client';
import { CREATE_PARTNER_ACCOUNT_EMPLOYEE } from '../../../../actions/create';

const ModalInviteMember = ({ show, hideModal, partnerAccountId, query, getVariables }) => {
  const classes = useStyles();
  const { handleSubmit, control } = useForm();

  const [setCreateAccount, { loading }] = useMutation(CREATE_PARTNER_ACCOUNT_EMPLOYEE);

  const onSubmit = (dataInput) => {
    setCreateAccount({
      variables: {
        partnerAccountId,
        email: dataInput.email,
      },
      refetchQueries: [{ query: query, variables: getVariables }],
    })
      .then(() => toast.success('Success'))
      .catch((err) => toast.error(err.message));
    hideModal();
  };

  if (loading) return <Preloader />;

  return (
    <div>
      <Dialog
        className={classes.dialog}
        maxWidth="md"
        open={show}
        onClose={() => {
          hideModal();
        }}
      >
        <div className={classes.modal}>
          <div className={classes.header}>
            <Typography variant="h6">Invite member</Typography>
            <Button className={classes.close} onClick={() => hideModal()}>
              <CloseIcon />
            </Button>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.modalBody}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField
                    onChange={onChange}
                    value={value}
                    label="Email"
                    variant="outlined"
                    className={classes.input}
                    style={{ marginBottom: 30 }}
                  />
                )}
              />
            </div>
            <div className={classes.modalFooter}>
              <Button className={`${classes.button} ${classes.cancel}`} onClick={() => hideModal()}>
                Cancel
              </Button>
              <Button type="submit" className={`${classes.button} ${classes.invite}`}>
                invite
              </Button>
            </div>
          </form>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalInviteMember;
